/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { Scrollbar } from 'react-scrollbars-custom';
import { themeToken } from '../../utils/cpds-utils';


/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

*/
const CpdsScrollbarStyleTag = styled(Scrollbar)`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
    /* Start styles for component here */
    width: 100%;
    height: 100%;
    max-width: 100%;
    .ScrollbarsCustom-Wrapper {
      top: 0;
      bottom: 0;
      left: 0;
      right: 3px;
    }
    .ScrollbarsCustom-TrackY,
    .ScrollbarsCustom-TrackX {
      position: absolute;
      &:before {
        content: '';
        position: absolute;
        background-color: ${token?.scrollbar_track_color};
      }
    }
    .ScrollbarsCustom-ThumbY,
    .ScrollbarsCustom-ThumbX {
      background: ${token?.scrollbar_thumb_color};
      cursor: pointer;
    }
    .ScrollbarsCustom-TrackY {
      right: 0;
      top: 0;
      height: 100%;
      width: 3px;
      &:before {
        top: 0;
        left: 1px;
        width: 1px;
        height: 100%;
      }
    }
    .ScrollbarsCustom-ThumbY {
      width: 100%;
    }
    .ScrollbarsCustom-TrackX {
      left: 0;
      bottom: 0;
      width: 100%;
      height: 3px;
      &:before {
        top: 1px;
        left: 0;
        height: 1px;
        width: 100%;
      }
    }
    .ScrollbarsCustom-ThumbX {
      height: 100%;
    }
    ${(props) => props?.styleOverrides}
  `}
  }
`;

export { CpdsScrollbarStyleTag };
